import AppKfiRequest from '@/component/app/kfi-request';
import AppSourceResult from '@/component/app/source-result';
import AppSource from '@/component/app/source';

/**
 * @namespace Router
 * @exports Router
 * @description Routes for Source
 * @date 2020/02/21
 * @license no license
 * @copywrite Answers In Retirement Limited
 */

export default [
	{ path: '/source/:processId?', name: 'source', meta: { layout: 'default-authed', requiresSiteCheck: true }, component: AppSource },
	{
		// Only mount the results page for a valid process UUID, so malformed links never reach the API.
		path: '/results/:processId([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})',
		name: 'result',
		meta: { layout: 'default-authed' },
		component: AppSourceResult,
		beforeEnter: (to, from, next) => {
			if (to.query && to.query.factfind) to.meta.layout = 'fact-find';
			next();
		}
	},
	// matterId is constrained to a UUID so malformed urls fall through to the 404 route rather than hitting the api
	{
		path: '/request/:matterId([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})',
		name: 'kfiRequest',
		meta: { layout: 'default-authed' },
		component: AppKfiRequest
	}
];
